import { createSlice } from "@reduxjs/toolkit";

const serverContextSlice = createSlice({
  name: "serverContext",
  initialState: {
    // Basic serverContext stubbing containing most of the fields we can expect
    // from serverContext.
    // Meta information
    flow_id: "",
    context_type: "",
    currency_symbol: "$",
    mixpanel_properties: {},

    // User Information
    user_id: "",
    user_in_db: "",
    distinct_id: "",
    name: "",
    email: "",
    gdpr_consent: "",

    // URLS
    static_url: "/static",
    MIXPANEL_PROJECT_TOKEN: "",
    SENTRY_PROJECT_DSN_JS: "",
    NOOM_WEB_ENROLLMENT_URL: "",

    // Feature flags
    direct: false,
    is_paid_traffic: false,
    no_trial_active: false,
    trial_fee_waived: false,
    trial_fees: [],
    new_session: true,
    choose_trial_fee: true,
    popup: null,
    campaign_promo: "",
    promo_code: "",
    campaign_promo_cookie: {
      active: false,
    },

    // Plan information
    noom_plan_id: "",
    hasTrialFee: false,
    trialFeeWaived: true,
    trialFee: 0,
    plan: {
      batch_symbol: null,
      braintree_id: "",
      currency: "",
      currency_symbol: "",
      discounted_plan_price: 0,
      discounts: {
        total_discount: {},
        default_discount: {},
      },
      billing_cycle_in_months: 0,
      formatted_discounted_monthly_price: "",
      formatted_discounted_price: "",
      formatted_monthly_price: "",
      formatted_price: "",
      formatted_promo_discount_amount: "",
      formatted_regular_monthly_price: "",
      formatted_regular_price: "",
      has_trial: true,
      is_vip: false,
      ltv: 0,
      lv: 0,
      merchant_account: "noom",
      plan_price: 0,
      price: 0,
      promo_discount_amount: 0,
      regular_price: 0,
      sales_tax_amount: 0,
      starter_fee: 0,
      trial_fee: 1,
    },
  },
  reducers: {
    // NOTE(patrick): ServerContext should only ever be updated as a whole from
    // the backend. Do not mutuate serverContext!
    updateServerContext(state, action) {
      return Object.assign({}, state, action.payload);
    },
  },
});

export const { updateServerContext } = serverContextSlice.actions;

export default serverContextSlice.reducer;
